import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../auth/AuthContext';

export default function NewsDetailPage() {
  const { id } = useParams();
  const { user } = useAuth();

  const [news, setNews] = useState(null);
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState('');
  const [error, setError] = useState(null);

  // ------------------ Load News ------------------
  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`/api/news/${id}`);
        setNews(data);

        // اگر کاربر قبلاً رأی داده باشد، مقدار را ست کن
        if (user && data.ratings) {
          const userRating = data.ratings.find(r => r.user === user.id);
          if (userRating) setRating(userRating.value);
        }
      } catch (err) {
        console.error(err);
        setError('Error loading news');
      }
    })();
  }, [id, user]);

  // ------------------ Submit Rating ------------------
  async function submitRating(value) {
  try {
    const { data } = await axios.post(`/api/news/${id}/rate`, {
      userId: user?.id,
      rating: value
    });

    setRating(value);

    // آرایه‌ی ratings را از backend بگیر و جایگزین کن
    setNews(prev => ({
      ...prev,
      ratings: data.ratings
    }));
  } catch (err) {
    console.error(err);
    setError('Error submitting rating');
  }
}



  // ------------------ Submit Comment ------------------
  async function submitComment(e) {
    e.preventDefault();
    try {
      const { data } = await axios.post(`/api/news/${id}/comments`, {
        userId: user?.id,
        text: comment
      });

      setNews(prev => ({
        ...prev,
        comments: [...prev.comments, data.comment]
      }));

      setComment('');
    } catch (err) {
      console.error(err);
      setError('Error submitting comment');
    }
  }

  if (!news) return <p className="text-center py-5">Loading...</p>;

  // محاسبه میانگین امتیاز
  const averageRating = news.ratings?.length
    ? (
        news.ratings.reduce((sum, r) => sum + r.value, 0) /
        news.ratings.length
      ).toFixed(1)
    : 0;

  return (
    <div className="container py-5">
      {/* Title */}
      <h1 className="mb-3">{news.title}</h1>

      {/* Thumbnail */}
      {news.thumbnailUrl && (
        <img
          src={news.thumbnailUrl}
          alt={news.title}
          className="img-fluid mb-4 rounded shadow-sm"
        />
      )}

      {/* Summary */}
      <p className="text-muted">{news.summary}</p>

      {/* Content */}
      <div
        className="mb-4"
        dangerouslySetInnerHTML={{ __html: news.content }}
      />

      {/* Rating Section */}
      <div className="mt-4">
        <h5>Rate this news:</h5>

        {user ? (
          <div className="mb-2">
            {[1, 2, 3, 4, 5].map(v => (
              <button
                key={v}
                className={`btn btn-sm me-2 ${
                  rating === v ? 'btn-primary' : 'btn-outline-primary'
                }`}
                onClick={() => submitRating(v)}
              >
                {v} ★
              </button>
            ))}
          </div>
        ) : (
          <p className="text-muted">🔒 Please log in to rate.</p>
        )}

        <p className="mt-2">Average rating: {averageRating} ★</p>
      </div>

      {/* Comments Section */}
      <div className="mt-5">
        <h5>Comments</h5>

        {user ? (
          <form onSubmit={submitComment} className="mb-3">
            <textarea
              className="form-control mb-2"
              value={comment}
              onChange={e => setComment(e.target.value)}
              placeholder="Write your comment..."
              required
            />
            <button className="btn btn-success btn-sm">Submit Comment</button>
          </form>
        ) : (
          <p className="text-muted">🔒 Please log in to comment.</p>
        )}

        <ul className="list-group">
          {news.comments?.map(c => (
            <li key={c._id} className="list-group-item">
              <strong>{c.user?.name || 'User'}:</strong> {c.text}
              <small className="text-muted d-block">
                {new Date(c.createdAt).toLocaleString()}
              </small>
            </li>
          ))}
        </ul>
      </div>

      {error && <div className="alert alert-danger mt-3">{error}</div>}
    </div>
  );
}
